var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19368_33024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.856 9.28095L6.48101 5.78095L2.10601 9.28095C2.00344 9.36302 1.88572 9.4241 1.75955 9.46067C1.63339 9.49725 1.50126 9.50863 1.3707 9.49414C1.24014 9.47965 1.11371 9.43959 0.998633 9.37625C0.883556 9.3129 0.782082 9.22751 0.700006 9.12495C0.61793 9.02239 0.556858 8.90466 0.520279 8.7785C0.483699 8.65233 0.472328 8.5202 0.486814 8.38964C0.5013 8.25908 0.541359 8.13265 0.604705 8.01758C0.668052 7.9025 0.753444 7.80102 0.856006 7.71895L5.85601 3.71895C6.03337 3.57694 6.2538 3.49957 6.48101 3.49957C6.70821 3.49957 6.92864 3.57694 7.10601 3.71895L12.106 7.71895C12.3131 7.88471 12.4459 8.12596 12.4752 8.38964C12.5045 8.65332 12.4278 8.91781 12.262 9.12495C12.1799 9.22751 12.0785 9.3129 11.9634 9.37625C11.8483 9.43959 11.7219 9.47965 11.5913 9.49414C11.3276 9.5234 11.0631 9.44671 10.856 9.28095Z",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19368_33024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.480957 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUp);
export default __webpack_public_path__ + "static/media/dropUp.1d00d7ae9818991ecab2f4cca3084170.svg";
export { ForwardRef as ReactComponent };